import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'

import {
  CurrencyService,
  CURRENCY_CONTEXT_ID,
  LanguageService,
  OccEndpointsService,
  SiteContextConfig
} from '@spartacus/core'
import { combineLatest, Observable } from 'rxjs'
import { filter, map, switchMap, take } from 'rxjs/operators'
import { EbBaseSite } from '../interfaces/eb-site-context.interface'
import { EbBaseSiteService } from '../services/eb-base-site.service'

@Injectable({ providedIn: 'root' })
export class EbSiteContextInterceptor implements HttpInterceptor {
  activeCurr: string

  constructor(
    private readonly languageService: LanguageService,
    private readonly currencyService: CurrencyService,
    private readonly occEndpoints: OccEndpointsService,
    private readonly config: SiteContextConfig,
    private readonly ebBaseSiteService: EbBaseSiteService
  ) {
    this.activeCurr = this.config.context?.[CURRENCY_CONTEXT_ID]?.[0]

    this.currencyService.getActive().subscribe(data => {
      this.activeCurr = data
    })
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes('/basesites')) {
      return combineLatest([
        this.ebBaseSiteService.getActiveContext(),
        this.ebBaseSiteService.getAll(),
        this.languageService.getActive()
      ]).pipe(
        filter(([activeContext, allBaseSites, language]) => !!activeContext && !!language),
        take(1),
        map(([activeContext, allBaseSites, language]) => {
          if (
            !request.url.includes(this.occEndpoints.getBaseUrl()) &&
            this.occEndpoints.getBaseUrl().includes(activeContext.uid) &&
            request.url.includes('/occ/v2/')
          ) {
            const baseUrl = this.occEndpoints.getBaseUrl().replace(/\/+$/, '')
            const endpoint = this.getEndpointWithoutBaseUrl(
              request.url,
              activeContext,
              allBaseSites
            ).replace(/^\/+/, '')

            return request.clone({
              url: `${baseUrl}/${endpoint}`,
              setParams: {
                lang: language,
                curr: this.activeCurr
              }
            })
          } else {
            return request.clone({
              setParams: {
                lang: language,
                curr: this.activeCurr
              }
            })
          }
        }),
        switchMap(req => next.handle(req))
      )
    } else {
      return this.languageService.getActive().pipe(
        take(1),
        map(activeLang => {
          if (request.url.includes(this.occEndpoints.getBaseUrl())) {
            return request.clone({
              setParams: {
                lang: activeLang,
                curr: this.activeCurr
              }
            })
          } else {
            return request
          }
        }),
        switchMap(req => next.handle(req))
      )
    }
  }
  private getEndpointWithoutBaseUrl(
    url: string,
    activeContext: EbBaseSite,
    allBaseSites: EbBaseSite[]
  ): string {
    const urlWithoutBaseSite = this.occEndpoints.getBaseUrl().replace(activeContext.uid, '')
    const urlWithoutBaseUrl = url.replace(urlWithoutBaseSite, '')
    const baseSiteIncludedInUrl = allBaseSites.find(site => urlWithoutBaseUrl.includes(site.uid))
    if (baseSiteIncludedInUrl) {
      return urlWithoutBaseUrl.replace(baseSiteIncludedInUrl.uid, '')
    } else {
      return urlWithoutBaseUrl
    }
  }
}
